import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import { useFamilyChild } from './FamilyShell';
import { formatWhen } from './familyFormat';

export default function FamilyClasses() {
  const { child, batches } = useFamilyChild();
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h5">Classes</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>For {child.firstName}</Typography>
      {batches.length === 0 && (
        <Typography color="text.secondary">No class time to show yet.</Typography>
      )}
      {batches.map((b) => (
        <Card key={b.batchId} sx={{ mb: 2 }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="subtitle2" color="text.secondary">Weekly time</Typography>
              <Chip size="small" label={b.status} />
            </Box>
            <Typography variant="h6" sx={{ mt: 1 }}>{b.scheduleSummary || b.batchName}</Typography>
            <Typography color="text.secondary">
              {b.timezone} · with {b.primaryTeacherName}
              {b.secondaryTeacherName ? ` and ${b.secondaryTeacherName}` : ''}
            </Typography>
            {b.upcoming?.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Upcoming</Typography>
                {b.upcoming.map((u) => (
                  <Typography
                    key={u.sessionId || u.date}
                    color="text.secondary"
                    sx={{ cursor: u.sessionId ? 'pointer' : 'default', py: 0.5 }}
                    onClick={() => u.sessionId && navigate(`/family/classes/${u.sessionId}`)}
                  >
                    {formatWhen(u)}
                  </Typography>
                ))}
              </Box>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
